import styled from 'styled-components';

import { COLORS } from 'constants/colors';
import { FONTS, FONTS_WEIGHT } from 'constants/fonts';

export const DateContainer = styled.div`
  background-color: ${COLORS.Grey8};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  padding: 32px;
  width: 80px;
  height: 120px;
  margin-left: 24px;
`;

export const DayText = styled.p`
  margin: 0;
  font-size: 80px;
  font-weight: ${FONTS_WEIGHT.TEXT_BOLD};
  color: ${COLORS.colorTextHeading};
`;

export const YearText = styled.p`
  margin: 0;
  font-size: ${FONTS.BASE_TEXT_FONT};
  font-weight: ${FONTS_WEIGHT.TEXT_REGULAR};
  color: ${COLORS.colorTextHeading};
`;

export const MonthText = styled.p`
  margin: 0;
  font-size: ${FONTS.OVERLAY_FONT};
  font-weight: ${FONTS_WEIGHT.TEXT_BOLD};
  color: ${COLORS.colorTextHeading};
`;

export const TimeText = styled.p`
  margin-top: 8px;
  font-size: ${FONTS.OVERLAY_FONT};
  font-weight: ${FONTS_WEIGHT.TEXT_BOLD};
  color: ${COLORS.colorTextHeading};
`;
